import { useHubMethod } from '@Contexts/signal';
import { useToasts } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useNotifyCreatedInvoices } from './Billing';
import { useNotifyBookedContainerRent } from './Orders/useNotifyBookedContainerRent';
import { MessagingConstants } from '@Model';
import { useRemoteLogout } from './useRemoteLogout';
import { parseApiMessages } from '@utils/parseApiMessages';

export function useGlobalToastHandler() {
    const { pushAllToasts } = useToasts();

    const showAllToasts = useCallback(
        (message: string) => {
            pushAllToasts(parseApiMessages(message));
        },
        [pushAllToasts],
    );

    useHubMethod(MessagingConstants.notification, showAllToasts);
}

export function useGlobalActionMessageHandlers() {
    useRemoteLogout();
    useNotifyCreatedInvoices();
    useNotifyBookedContainerRent();
}
